// components/ui/Notification.tsx
import React from 'react';
import { Check } from 'lucide-react';

interface NotificationProps {
  show: boolean;
  message: string;
  type?: 'success' | 'error' | 'warning' | 'info';
}

const Notification: React.FC<NotificationProps> = ({
  show,
  message,
  type = 'success'
}) => {
  if (!show) return null;

  const getNotificationStyles = () => {
    switch (type) {
      case 'success':
        return 'bg-green-500 text-white';
      case 'error':
        return 'bg-red-500 text-white';
      case 'warning':
        return 'bg-yellow-500 text-white';
      case 'info':
        return 'bg-blue-500 text-white';
      default:
        return 'bg-green-500 text-white';
    }
  };

  return (
    <div className={`${getNotificationStyles()} px-6 py-3 flex items-center justify-center animate-in slide-in-from-top duration-300`}>
      <Check className="mr-2" size={18} />
      {message}
    </div>
  );
};

export default Notification;